import history from 'history/browser'
import React, { Component } from 'react'
import './BackButton.css'

/**
 	Bouton de retour,
 	Permet de visé une view particuliere avec la variable "targetView"
	Si le variable "targetView" n'est pas renseigné, préalise un decrement simple de l'index de vue
**/
class BackButton extends Component {
    handleClick() {
        history.back()
        /*if (this.props.targetView !== undefined){
			store.dispatch({ type: 'SET_VIEW',value : this.props.targetView });
		}
		else{
			store.dispatch({ type: 'DECR_VIEW' });
		}*/
    }

    render() {
        return (
            <div
                className="BackButton pointer"
                onClick={(e) => this.handleClick()}
            >
                <img
                    src="svg/retour.svg"
                    className="BackButton"
                    alt="boutton de retour en arrière"
                />
            </div>
        )
    }
}

export default BackButton
